import { FC } from 'react';
import styles from './index.module.less';
import IconFont from '@/common/components/IconFont';
import Paragraph from 'antd/lib/typography/Paragraph';

/**
 * @Description 目标品牌
 */
const TargetBrand: FC<{
  data: any;
  amapIns: any;
  marker: any;
  activeMarker: any;
  setCurDetail: any;
}> = ({
  data,
  amapIns,
  marker,
  activeMarker,
  setCurDetail,
}) => {

  return <div className={styles.competitorOverview}>
    <IconFont
      iconHref={'iconic_close_colour_seven'}
      className={styles.closeIcon}
      onClick={() => {
        setCurDetail({});
        amapIns.remove(marker);
        amapIns.remove(activeMarker);
      }}
    />
    {/* <div className='fs-14 bold pr-16 ellipsis-2'>{data?.name}</div> */}
    <Paragraph
      style={{ width: 170, marginBottom: 0 }}
      ellipsis={{
        tooltip: data?.name,
        rows: 2,
      }}>
      <span className='fs-14 bold pr-16'>
        {data?.name}
      </span>
    </Paragraph>
    {
      data?.address ? <div className='c-999 fs-12 mt-6'>
        {data?.address}
      </div> : <></>
    }
  </div>;
};

export default TargetBrand;
